// extracted by mini-css-extract-plugin
export var borderRadius = "_ds-4";
export var large = "_ds-3";
export var logoContainer = "_ds-0";
export var nameLogo = "_ds-2";
export var small = "_ds-1";